import React from 'react';
import AlertGenericModal from 'react/containers/modals/AlertGenericModal';

import { renderComponent } from "react/utils/renderUtils";

Greenmile.Components = Greenmile.Components || {};
/**
 * Public Modal Alert (to override the browser Alert func)
 * @param {String} message text to show into modal Alert (Can be a resource key or a text)
 * @param {String} [title] Optional. Default value is "Alert"
 * @param {Function} [confirmClickButton] Optional. Callback function when have a confirmation action
 * @param {Function} [cancelClickButton] Optional. Callback function to Cancel button if so
 * @param {Object} [options] Optional. Default is {}
 */
Greenmile.Components.AlertModal = function (
  message,
  title,
  confirmClickButton,
  cancelClickButton,
  options = {}
) {
    this.show = () => {
      try {
        const config = {
          title,
          confirmClickButton,
          cancelClickButton,
          ...options
        };

        renderComponent(
          <AlertGenericModal
            open={true}
            i18n={Monet.I18n}
            message={message}
            { ...config }
          />,
          document.getElementById('templates_container')
        );
      } catch (error) {
        new Monet.Exception.ReturnError(this,
          'Error trying to instantiate an Alert Modal')
          .console();
      }

    }

    return this;
};
